<template>
  <div>
    <div class="gap">
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">基础信息</div>
        </div>
        <div>
          <span>干皮批次：</span>
          <span>{{ formData.dryPeelBizNo || '-' }}</span>
        </div>
      </div>

      <el-form :model="formData" ref="form" label-suffix="：">
        <el-row :gutter="20">
          <el-col :span="12" :xs="12">
            <el-form-item label="客户名称"> {{ formData.customerName }} </el-form-item>
          </el-col>
          <el-col :span="12" :xs="12">
            <el-form-item label="产品名称">
              {{ formData.productName }}
            </el-form-item>
          </el-col>
          <el-col :span="12" :xs="12">
            <el-form-item label="产区"> {{ formData.productionArea }} </el-form-item>
          </el-col>
          <el-col :span="12" :xs="12">
            <el-form-item label="年份"> {{ formData.pickingDateTime }} </el-form-item>
          </el-col>
          <el-col :span="12" :xs="12">
            <el-form-item label="培育方式"> {{ formData.cultivationMethodSpecValueKey }} </el-form-item>
          </el-col>
          <el-col :span="12" :xs="12">
            <el-form-item label="成熟度"> {{ formData.ripenessLevelSpecAttrValueKey }} </el-form-item>
          </el-col>
          <el-col :span="12" :xs="12">
            <el-form-item label="备注"> {{ formData.remark }} </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="gap">
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">入库验收</div>
        </div>
      </div>
      <div class="hbwtween">
        <div class="flex-1">
          <TablePublic :colLists="halfColLists" :tableData="orderList" :paginationFlag="false"> </TablePublic>
        </div>
      </div>
    </div>

    <div class="gap">
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">照片信息</div>
        </div>
      </div>
      <div class="hbwtween">
        <div class="file" @click="lookFile()">
          <img class="file-icon" src="https://peelprod.oss-cn-shenzhen.aliyuncs.com/biz/173026022759281382.png" />
          <div class="file-name">验收照片</div>
        </div>
      </div>
    </div>

    <div class="gap">
      <div class="title title-mb">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">历史修改记录</div>
        </div>
      </div>
      <div class="hbwtween">
        <div class="flex-1">
          <TablePublic :colLists="historyColLists" :tableData="historyTableData" :paginationFlag="false">
            <template slot="modificationDesc" slot-scope="scope">
              <div style="white-space: normal; text-align: left">{{ scope.data.modificationDesc }}</div>
            </template>
            <template slot="reason" slot-scope="scope">
              <div style="white-space: normal">{{ scope.data.reason }}</div>
            </template>
          </TablePublic>
        </div>
      </div>
    </div>

    <Mdialog
      title="历史修改记录"
      :visible.sync="historyDialog"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="historyDialog = false"
    >
      <TablePublic :colLists="historyColLists" :tableData="historyTableData" :paginationFlag="false">
        <template slot="modificationDesc" slot-scope="scope">
          <div style="white-space: normal; text-align: left">{{ scope.data.modificationDesc }}</div>
        </template>
        <template slot="reason" slot-scope="scope">
          <div style="white-space: normal">{{ scope.data.reason }}</div>
        </template>
      </TablePublic>
    </Mdialog>

    <Mdialog
      title="查看照片视频"
      :visible.sync="fileDialog"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="fileDialog = false"
    >
      <Photo :imgArr="imgArr" />
    </Mdialog>
  </div>
</template>

<script>
import TablePublic from '@/components/tablePublic.vue'
import Mdialog from '@/components/Mdialog'
import Photo from '@/components/photo.vue'

import { getDryInboundData } from '@/api/manage/report'

import { isDef } from '@/utils/is'
export default {
  name: 'skinDetailReport',
  components: {
    TablePublic,
    Mdialog,
    Photo,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
    },
  },
  data() {
    const _this = this
    return {
      fileDialog: false,
      weightDialog: false,
      historyDialog: false,

      importHeaders: '',
      uploadPath: '',

      skinColLists: [
        {
          prop: '',
          label: '规格',
          isTrue: true,
          formatter(row) {
            const arr = [
              row.ripenessLevelSpecAttrValueKey,
              row.locDetails?.slice(row.locDetails?.lastIndexOf(',') + 1),
              row.cultivationMethodSpecValueKey,
            ]
            return arr.filter((item) => !!item).join('-')
          },
        },
        {
          prop: 'freshFruitTotalNetWeight',
          label: '鲜果总净重（斤）',
          isTrue: true,
        },
        {
          prop: 'freshPeelTotalNetWeight',
          label: '鲜皮总净重（斤）',
          isTrue: true,
        },
        {
          prop: 'peelRate',
          label: '鲜皮率（%）',
          isTrue: true,
          formatter(row) {
            return row.peelRate ? _this.myFixed(row.peelRate, 2) : ''
          },
        },
        {
          prop: 'createBy',
          label: '鲜皮记录员',
          isTrue: true,
        },
        {
          prop: 'createTime',
          label: '生产加工日期',
          isTrue: true,
          formatter(row) {
            return row.createTime ? _this.parseTime(row.createTime, '{y}-{m}-{d}') : ''
          },
        },
        {
          label: '操作',
          prop: '',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],

      halfColLists: [
        {
          prop: 'totalNetWeight',
          label: '应收净重（斤）',
          isTrue: true,
        },
        {
          prop: 'unacceptedNetWeight',
          label: '不达标净重（斤）',
          isTrue: true,
        },
        {
          prop: 'acceptedNetWeight',
          label: '可入库净重（斤）',
          isTrue: true,
        },
        {
          prop: 'storedNetWeight',
          label: '已入库净重（斤）',
          isTrue: true,
        },
        {
          prop: 'inspectionFlag',
          label: '验收结果',
          isTrue: true,
          formatter(row) {
            return isDef(row.inspectionFlag) ? (row.inspectionFlag === 1 ? '达标' : '不达标') : '-'
          },
        },
        {
          prop: 'inventoryLocation',
          label: '仓库',
          isTrue: true,
        },
        {
          prop: 'storageArea',
          label: '库区',
          isTrue: true,
        },
      ],

      historyColLists: [
        {
          prop: 'modificationDesc',
          label: '修改内容',
          isTrue: true,
          formSolt: true,
        },
        {
          prop: 'reason',
          label: '修改原因',
          isTrue: true,
          formSolt: true,
        },
        {
          prop: 'createTime',
          label: '修改日期',
          isTrue: true,
          formatter(row) {
            return row.createTime ? _this.parseTime(row.createTime, '{y}-{m}-{d}') : ''
          },
          width: '150',
        },
        {
          prop: 'createBy',
          label: '修改人',
          isTrue: true,
          width: '150',
        },
      ],

      formData: { attachments: [] },
      historyTableData: [],

      tableData: [],

      orderList: [],
      attachList: [],

      imgArr: [],
      videoArr: [],
    }
  },
  watch: {
    data: {
      handler(form) {
        if (!form) return
        this.getDetail(form)
      },
      immediate: true,
    },
  },
  mounted() {
    console.log(3333333333)
  },
  methods: {
    async getDetail({ inboundId, pickingBatchBizNo, dryPeelBizNo }) {
      const data = await getDryInboundData({
        inboundId,
        bizNo: pickingBatchBizNo,
        dryPeelBizNo,
        purchasePlanId: this.$route.query.purchasePlanId,
      })
      if (!data.flag || data.code !== 200) return

      const baseData = data.data?.base || {}
      this.formData = baseData
      this.historyTableData = data.data?.amdRecList || []
      this.orderList = [
        {
          ...data.data.order,
          totalNetWeight: baseData.totalNetWeight,
        },
      ]
      this.attachList = data.data.order.attachments
    },
    lookFile() {
      this.imgArr = this.attachList?.filter((item) => item.type == 2).map((item) => item.url) || []
      this.fileDialog = true
    },
    back() {
      this.$router.push('/taskPick')
    },
    historySummaryMethod(param) {
      const { columns, data } = param
      const sums = []

      // this.settleAmountPayAmount = 0
      columns.forEach((column, index) => {
        if (index == 1) {
          sums[index] = '合计'
          return
        }

        if (index == 3) {
          sums[index] = data.reduce((prev, cur) => {
            return prev + (cur.num || 0)
          }, 0)
          return
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
    weightSummaryMethod(param) {
      const { columns, data } = param
      const sums = []

      // this.settleAmountPayAmount = 0
      columns.forEach((column, index) => {
        if (index == 1) {
          sums[index] = '合计'
          return
        }

        if (index == 3) {
          sums[index] = data.reduce((prev, cur) => {
            return prev + (cur.num || 0)
          }, 0)
          return
        }
        if (index == 4) {
          sums[index] = data.reduce((prev, cur) => {
            return prev + (cur.num || 0)
          }, 0)
          return
        }
        if (index == 5) {
          sums[index] = data.reduce((prev, cur) => {
            return prev + (cur.num || 0)
          }, 0)
          return
        }
        if (index == 6) {
          sums[index] = data.reduce((prev, cur) => {
            return prev + (cur.num || 0)
          }, 0)
          return
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
    toWeightRecord() {},
    tohistory(data) {
      this.historyTableData = data.resumeList
      this.historyDialog = true
    },

    beforeAvatarUpload() {},
    handleAvatarError() {},
    handlePropress() {},
    handleAvatarSuccess() {},
    handleDel() {},
    handleDelFile() {},
  },
}
</script>

<style scoped lang="less">
@import '~@/assets/variables.less';
@import '../../../../assets/form.less';

.el-icon-arrow-left {
  font-size: 30px;
  margin-top: 5px;
  color: @theme-color;
  cursor: pointer;
}

.gap {
  margin-bottom: 30px;
}
.hbwtween {
  display: flex;
  justify-content: space-between;
}

.flex-1 {
  flex: 1;
}

.file {
  display: inline-block;
  cursor: pointer;
  &-icon {
    width: 100px;
    height: 100px;
  }
  &-name {
    font-size: 16px;
    text-align: center;
  }
}

::v-deep {
  .m-steps {
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .el-form-item__label {
    color: #000;
  }
}
</style>
